<template>
  <transition
    name="custom-classes-transition"
    enter-active-class="animated slideInDown"
    leave-active-class="animated slideOutUp"
  >
    <section v-if="show" class="hero app-menu is-primary is-overlay is-clipped">
      <div class="container">
        <!--div class="hero-head">
          <div class="level" style="margin-bottom:40px">
            <span class="level-left"></span>
            <div class="buttons level-right">
              <app-social-networks/>
            </div>
          </div>
        </div-->
        <div class="hero-body">
          <transition-group
            appear
            name="custom-classes-transition"
            tag="div"
            enter-active-class="animated slideInDown slow"
            v-on:before-enter="beforeEnter"
            class="columns is-centered"
          >
            <app-network-column
              v-for="(column,index) in networkColumns"
              :title="column.title"
              :links="column.links"
              :key="column.title"
              :data-index="index+0"
              class="is-narrow"
            ></app-network-column>
          </transition-group>
           <app-social-networks/>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import AppNetworkColumn from './AppNetworkColumn'
import AppSocialNetworks from './AppSocialNetworks'
export default {
  props: { show: { type: Boolean, default: false } },
  components: {
    AppNetworkColumn,
    AppSocialNetworks
  },
  data () {
    return {
      networkColumns: [
        {
          title: 'educate',
          links: [
            {
              name: 'app_education',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/app-education/'
            },
            {
              name: 'scratch_challenge',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/scratch-challenge/'
            },
            { name: 'msteam', url: '' }
          ]
        },
        {
          title: 'transform',
          links: [
            {
              name: 'eduhack',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/edu_hack/'
            },
            {
              name: 'changing_education',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/changing-education-together/'
            }
          ]
        },
        {
          title: 'collaborate',
          links: [
            {
              name: 'toolbox',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mschools-toolbox/'
            },
            {
              name: 'mobile_history_map',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mobile-history-map/'
            },
            { name: 'experts', url: 'http://experts.mobileworldcapital.com/' }
          ]
        },
        {
          title: 'compete',
          links: [
          //  { name: 'sdg_challenge', url: 'http://sdg.mschools.com' },
            {
              name: 'student_awards',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mschools-student-awards/'
            },
            {
              name: 'mobile_learning_awards',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mobile-learning-awards/'
            },
            {
              name: 'techcamp',
              url:
                'http://mschools.mobileworldcapital.com/our-initiatives/mschools-techcamp/'
            },
            {
              name: 'yomo',
              url: 'http://mschools.mobileworldcapital.com/mschools-yomo/'
            }
          ]
        },
        {
          title: 'stay_tuned',
          links: [
            {
              name: 'agenda',
              url: 'http://mschools.mobileworldcapital.com/agenda-and-events/'
            },
            {
              name: 'blog',
              url: 'http://mschools.mobileworldcapital.com/news-picks/'
            },
            {
              name: 'about',
              url: 'http://mschools.mobileworldcapital.com/what-is-mschools/'
            },
            {
              name: 'newsletter',
              url: 'http://mschools.mobileworldcapital.com/newsletter/'
            },
            {
              name: 'contact',
              url: 'http://mschools.mobileworldcapital.com/contact/'
            }
          ]
        }
      ]
    }
  },
  methods: {
    beforeEnter: function (el) {
      el.style['animation-delay'] = Math.random() * 0.5 + 's'
    }
  }
  /* watch: {
    show: newVal => {
      document.getElementsByTagName("html")[0].style["overflow-y"] = newVal
        ? "hidden"
        : "auto";
    }
  } */
}
</script>

<style scoped lang="scss">
.app-menu {
  margin-top: 3.25rem;
  position: fixed;
  background-color: #063f5e !important;
  overflow-y: scroll !important;
  height: 100%;
}
.column:last-child {
  border-right: 1px solid #498edf !important;
  padding-right: 40px;
}

/deep/.menu-list a{
  color: white
}
</style>
